/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "DeviceAction": {
                "fields": {
                  "deviceActionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceActionType": {
                    "type": ".squareup.connect.v2.DeviceAction.DeviceActionType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "setDeviceNameDetails": {
                    "type": ".squareup.connect.v2.SetDeviceNameDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "fetchDeviceProfileDetails": {
                    "type": ".squareup.connect.v2.FetchDeviceProfile",
                    "id": 4,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deviceId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "shouldAck": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdBy": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "updatedBy": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.connect.v2.DeviceActionStatus",
                    "id": 11,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.connect.v2.DeviceActionFailureReason",
                    "id": 12,
                    "rule": "optional"
                  },
                  "rebootDeviceDetails": {
                    "type": ".squareup.connect.v2.RebootDeviceDetails",
                    "id": 13,
                    "rule": "optional"
                  },
                  "switchModesDetails": {
                    "type": ".squareup.connect.v2.SwitchModesDetails",
                    "id": 14,
                    "rule": "optional"
                  },
                  "failureReasonDetails": {
                    "type": ".squareup.connect.v2.DeviceActionFailureReasonDetails",
                    "id": 15,
                    "rule": "optional"
                  },
                  "pairWithSyncHubDetails": {
                    "type": ".squareup.connect.v2.PairWithSyncHubDetails",
                    "id": 16,
                    "rule": "optional"
                  },
                  "closeCashDrawerDetails": {
                    "type": ".squareup.connect.v2.CloseCashDrawerDetails",
                    "id": 17,
                    "rule": "optional"
                  },
                  "evaluateClsFieldsDetails": {
                    "type": ".squareup.connect.v2.EvaluateClsFieldsDetails",
                    "id": 18,
                    "rule": "optional"
                  },
                  "fetchPrinterProfilesDetails": {
                    "type": ".squareup.connect.v2.FetchPrinterProfilesDetails",
                    "id": 19,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeviceActionType": {
                    "values": {
                      "DEVICE_ACTION_TYPE_INVALID_TYPE": 0,
                      "FETCH_DEVICE_PROFILE": 1,
                      "SEND_DEVICE_UPDATE": 2,
                      "SET_DEVICE_NAME": 3,
                      "REBOOT_DEVICE": 4,
                      "SWITCH_MODES": 5,
                      "PAIR_WITH_SYNC_HUB": 6,
                      "CLOSE_CASH_DRAWER": 7,
                      "EVALUATE_CLS_FIELDS": 8,
                      "FETCH_PRINTER_PROFILES": 9
                    }
                  }
                }
              },
              "SetDeviceNameDetails": {
                "fields": {
                  "updatedDeviceName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "FetchDeviceProfile": {
                "fields": {
                  "deviceProfileId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "currentVersion": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RebootDeviceDetails": {
                "fields": {
                  "customMessage": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customOptions": {
                    "type": ".squareup.connect.v2.RebootDeviceDetails.RebootCustomOption",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "RebootCustomOption": {
                    "values": {
                      "UNKNOWN_OPTION": 0,
                      "FIFTEEN_MINUTES_DELAY": 1,
                      "THIRTY_MINUTES_DELAY": 2,
                      "ONE_HOUR_DELAY": 3,
                      "CANCEL": 4
                    }
                  }
                }
              },
              "SwitchModesDetails": {
                "fields": {
                  "modeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "autoConfirmSeconds": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 60
                    }
                  },
                  "customMessage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PairWithSyncHubDetails": {
                "fields": {
                  "localHubHostIp": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localHubHostDeviceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "localHubHostDeviceName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "localHubHostDeviceModel": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CloseCashDrawerDetails": {
                "fields": {
                  "cashDrawerClientUuid": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "autoConfirmSeconds": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 60
                    }
                  },
                  "customMessage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "EvaluateClsFieldsDetails": {
                "fields": {
                  "fields": {
                    "type": ".squareup.connect.v2.EvaluateClsFieldsDetails.EvaluateField",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "EvaluateField": {
                    "fields": {
                      "clsFieldName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "FetchPrinterProfilesDetails": {
                "fields": {
                  "updateTimestamp": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DeviceActionStatus": {
                "values": {
                  "DEVICE_ACTION_STATUS_INVALID_STATUS": 0,
                  "DEVICE_ACTION_STATUS_PENDING": 1,
                  "DEVICE_ACTION_STATUS_IN_PROGRESS": 2,
                  "DEVICE_ACTION_STATUS_CANCELLED": 3,
                  "DEVICE_ACTION_STATUS_COMPLETED": 4,
                  "DEVICE_ACTION_STATUS_FAILED": 5,
                  "DEVICE_ACTION_STATUS_ACTION_UNSUPPORTED": 6,
                  "DEVICE_ACTION_STATUS_ACK_UNSUPPORTED": 7,
                  "DEVICE_ACTION_STATUS_DEFERRED": 8
                }
              },
              "DeviceActionFailureReason": {
                "values": {
                  "DEVICE_ACTION_FAILURE_REASON_INVALID_TYPE": 0,
                  "DEVICE_ACTION_FAILURE_REASON_UNAUTHORIZED": 1,
                  "DEVICE_ACTION_FAILURE_REASON_PARSING_ERROR": 2,
                  "DEVICE_ACTION_FAILURE_REASON_FAILED_ON_DEVICE": 3,
                  "DEVICE_ACTION_FAILURE_REASON_NETWORK_ERROR": 4,
                  "DEVICE_ACTION_FAILURE_REASON_OTHER_ACTION_IN_PROGRESS": 5,
                  "DEVICE_ACTION_FAILURE_REASON_GATEKEEPER_BLOCKED_BY_CASHDRAWERS": 6,
                  "DEVICE_ACTION_FAILURE_REASON_GATEKEEPER_BLOCKED_BY_OUTAGE_MODE": 7,
                  "DEVICE_ACTION_FAILURE_REASON_GATEKEEPER_BLOCKED_BY_INCOMPLETE_TRANSACTIONS": 8,
                  "DEVICE_ACTION_FAILURE_REASON_GATEKEEPER_BLOCKED_BY_OPEN_TICKETS": 9,
                  "DEVICE_ACTION_FAILURE_REASON_GATEKEEPER_BLOCKED_BY_UNSYNCED_ORDERS": 10,
                  "DEVICE_ACTION_FAILURE_REASON_UNSUPPORTED_ON_DEVICE": 11,
                  "DEVICE_ACTION_FAILURE_REASON_UNSUPPORTED_ON_EMPLOYEE_SESSION": 12,
                  "DEVICE_ACTION_FAILURE_REASON_UNSUPPORTED_ON_RST_SUBSCRIPTION": 13
                }
              },
              "DeviceActionFailureReasonDetails": {
                "fields": {
                  "incompleteTransactionsDetails": {
                    "type": ".squareup.connect.v2.GatekeeperBlockedByIncompleteTransactionsDetails",
                    "id": 1,
                    "rule": "optional"
                  },
                  "openTicketsDetails": {
                    "type": ".squareup.connect.v2.GatekeeperBlockedByOpenTicketsDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unsyncedOrdersDetails": {
                    "type": ".squareup.connect.v2.GatekeeperBlockedByUnsyncedOrdersDetails",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GatekeeperBlockedByIncompleteTransactionsDetails": {
                "fields": {
                  "incompleteTransactionsCount": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GatekeeperBlockedByOpenTicketsDetails": {
                "fields": {
                  "openTicketsCount": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GatekeeperBlockedByUnsyncedOrdersDetails": {
                "fields": {
                  "unsyncedOrdersCount": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DeviceActionSnapshot": {
                "fields": {
                  "status": {
                    "type": ".squareup.connect.v2.DeviceActionStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failureReason": {
                    "type": ".squareup.connect.v2.DeviceActionFailureReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "updatedBy": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "failureReasonDetails": {
                    "type": ".squareup.connect.v2.DeviceActionFailureReasonDetails",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceAction && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceAction?.nested?.DeviceActionType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SetDeviceNameDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.FetchDeviceProfile && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.RebootDeviceDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.RebootDeviceDetails?.nested?.RebootCustomOption && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SwitchModesDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.PairWithSyncHubDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CloseCashDrawerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.EvaluateClsFieldsDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.EvaluateClsFieldsDetails?.nested?.EvaluateField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.FetchPrinterProfilesDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceActionStatus && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceActionFailureReason && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceActionFailureReasonDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GatekeeperBlockedByIncompleteTransactionsDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GatekeeperBlockedByOpenTicketsDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GatekeeperBlockedByUnsyncedOrdersDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceActionSnapshot) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceAction @ squareup/devices/external/device_action.proto at 12:1
 */
export const DeviceAction = $root.lookupType('squareup.connect.v2.DeviceAction');
fixType(DeviceAction, {
  deviceActionType: {
    required: true
  }
});
Builder.createAndAttachToType(DeviceAction);
/**
 * SOURCE DeviceActionType @ squareup/devices/external/device_action.proto at 24:3
 */
DeviceAction.DeviceActionType = $root.lookupEnum('squareup.connect.v2.DeviceAction.DeviceActionType').values;
/**
 * Action details messages
 *
 * SOURCE SetDeviceNameDetails @ squareup/devices/external/device_action.proto at 149:1
 */
export const SetDeviceNameDetails = $root.lookupType('squareup.connect.v2.SetDeviceNameDetails');
fixType(SetDeviceNameDetails, {
  updatedDeviceName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetDeviceNameDetails);
/**
 * SOURCE FetchDeviceProfile @ squareup/devices/external/device_action.proto at 155:1
 */
export const FetchDeviceProfile = $root.lookupType('squareup.connect.v2.FetchDeviceProfile');
fixType(FetchDeviceProfile, {
  deviceProfileId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FetchDeviceProfile);
/**
 * SOURCE RebootDeviceDetails @ squareup/devices/external/device_action.proto at 162:1
 */
export const RebootDeviceDetails = $root.lookupType('squareup.connect.v2.RebootDeviceDetails');
fixType(RebootDeviceDetails);
Builder.createAndAttachToType(RebootDeviceDetails);
/**
 * SOURCE RebootCustomOption @ squareup/devices/external/device_action.proto at 165:3
 */
RebootDeviceDetails.RebootCustomOption = $root.lookupEnum('squareup.connect.v2.RebootDeviceDetails.RebootCustomOption').values;
/**
 * SOURCE SwitchModesDetails @ squareup/devices/external/device_action.proto at 181:1
 */
export const SwitchModesDetails = $root.lookupType('squareup.connect.v2.SwitchModesDetails');
fixType(SwitchModesDetails, {
  modeId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SwitchModesDetails);
/**
 * SOURCE PairWithSyncHubDetails @ squareup/devices/external/device_action.proto at 194:1
 */
export const PairWithSyncHubDetails = $root.lookupType('squareup.connect.v2.PairWithSyncHubDetails');
fixType(PairWithSyncHubDetails);
Builder.createAndAttachToType(PairWithSyncHubDetails);
/**
 * SOURCE CloseCashDrawerDetails @ squareup/devices/external/device_action.proto at 212:1
 */
export const CloseCashDrawerDetails = $root.lookupType('squareup.connect.v2.CloseCashDrawerDetails');
fixType(CloseCashDrawerDetails);
Builder.createAndAttachToType(CloseCashDrawerDetails);
/**
 * SOURCE EvaluateClsFieldsDetails @ squareup/devices/external/device_action.proto at 225:1
 */
export const EvaluateClsFieldsDetails = $root.lookupType('squareup.connect.v2.EvaluateClsFieldsDetails');
fixType(EvaluateClsFieldsDetails);
Builder.createAndAttachToType(EvaluateClsFieldsDetails);
/**
 * SOURCE EvaluateField @ squareup/devices/external/device_action.proto at 231:3
 */
EvaluateClsFieldsDetails.EvaluateField = $root.lookupType('squareup.connect.v2.EvaluateClsFieldsDetails.EvaluateField');
fixType(EvaluateClsFieldsDetails.EvaluateField, {
  clsFieldName: {
    required: true
  }
});
Builder.createAndAttachToType(EvaluateClsFieldsDetails.EvaluateField);
/**
 * SOURCE FetchPrinterProfilesDetails @ squareup/devices/external/device_action.proto at 239:1
 */
export const FetchPrinterProfilesDetails = $root.lookupType('squareup.connect.v2.FetchPrinterProfilesDetails');
fixType(FetchPrinterProfilesDetails);
Builder.createAndAttachToType(FetchPrinterProfilesDetails);
/**
 * SOURCE DeviceActionStatus @ squareup/devices/external/device_action.proto at 243:1
 */
export const DeviceActionStatus = $root.lookupEnum('squareup.connect.v2.DeviceActionStatus').values;
/**
 * SOURCE DeviceActionFailureReason @ squareup/devices/external/device_action.proto at 281:1
 */
export const DeviceActionFailureReason = $root.lookupEnum('squareup.connect.v2.DeviceActionFailureReason').values;
/**
 * SOURCE DeviceActionFailureReasonDetails @ squareup/devices/external/device_action.proto at 327:1
 */
export const DeviceActionFailureReasonDetails = $root.lookupType('squareup.connect.v2.DeviceActionFailureReasonDetails');
fixType(DeviceActionFailureReasonDetails);
Builder.createAndAttachToType(DeviceActionFailureReasonDetails);
/**
 * SOURCE GatekeeperBlockedByIncompleteTransactionsDetails @ squareup/devices/external/device_action.proto at 340:1
 */
export const GatekeeperBlockedByIncompleteTransactionsDetails = $root.lookupType('squareup.connect.v2.GatekeeperBlockedByIncompleteTransactionsDetails');
fixType(GatekeeperBlockedByIncompleteTransactionsDetails);
Builder.createAndAttachToType(GatekeeperBlockedByIncompleteTransactionsDetails);
/**
 * SOURCE GatekeeperBlockedByOpenTicketsDetails @ squareup/devices/external/device_action.proto at 347:1
 */
export const GatekeeperBlockedByOpenTicketsDetails = $root.lookupType('squareup.connect.v2.GatekeeperBlockedByOpenTicketsDetails');
fixType(GatekeeperBlockedByOpenTicketsDetails);
Builder.createAndAttachToType(GatekeeperBlockedByOpenTicketsDetails);
/**
 * SOURCE GatekeeperBlockedByUnsyncedOrdersDetails @ squareup/devices/external/device_action.proto at 354:1
 */
export const GatekeeperBlockedByUnsyncedOrdersDetails = $root.lookupType('squareup.connect.v2.GatekeeperBlockedByUnsyncedOrdersDetails');
fixType(GatekeeperBlockedByUnsyncedOrdersDetails);
Builder.createAndAttachToType(GatekeeperBlockedByUnsyncedOrdersDetails);
/**
 * SOURCE DeviceActionSnapshot @ squareup/devices/external/device_action.proto at 361:1
 */
export const DeviceActionSnapshot = $root.lookupType('squareup.connect.v2.DeviceActionSnapshot');
fixType(DeviceActionSnapshot, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(DeviceActionSnapshot);